export class Calculation {
  order: number;
  name: string;
  displayName: string;
  numerator: number;
  denominator: number;
}

export class MoldLoss {
  shops: string[];
  roles: string[];
  constructor() {
    this.shops = [];
    this.roles = [];
  }
}

export class Config {
  moldLoss: MoldLoss;
  defectMappingEquipmentList: number[];
  calculations: Calculation[];
  constructor() {
    this.moldLoss = new MoldLoss();
    this.defectMappingEquipmentList = [];
    this.calculations = [];
  }
}

export class PlantFeatureSetting {
  id: string;
  plantId: string;
  config: Config;
}

export class PlantFeatureSettingPayload {
  id: string;
  plantId: string;
  config: string;
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/models/plants/plantFeatureSettings.ts